{
  "button-bar-for-selected-service": {
    "text": {
      "and-x-more": "und {{nr}} mehr",
      "duration": "Dauer",
      "select-service-hint": "Bitte wählen Sie mindestens eine Dienstleistung und die gewünschte Zeit aus, um fortzufahren"
    }
  }
}
